import { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Toast, Dropdown } from 'react-bootstrap';
import Pagination from './Pagination/Pagination';
import { IProgramsListContext, ProgramsListContext } from '../../../../../application/context/Programs/ProgramsList/ProgramsListContext';
import { IProgram } from '../../../../../domain/core/entities/programEntity';
import DisabledProgramModal from './DisabledProgramModal/DisabledProgramModal';
import DeleteProgramModal from './DeleteProgramModal/DeleteProgramModal';
import EnabledProgramModal from './EnabledProgramModal/EnabledProgramModal';

export default function ProgramsTable() {
    const { state } = useContext<IProgramsListContext>(ProgramsListContext);
    const { data, limit } = state.getProgramsState;

    const [programs, setPrograms] = useState<IProgram[]>(data);
    const [programSelected, setProgramSelected] = useState<IProgram>({} as IProgram);

    const getProgramStatus = (status: string) => {
        switch (status) {
            case "draft":
                return "Borrador";
            case "pendingForApproval":
                return "Pendiente por aprobar";
            case "approved":
                return "Aprobado";
            case "disabled":
                return "Deshabilitado";
        
            default:
                return "Borrador";
        }
    }

    const [showDisabledProgramModal, setShowDisabledProgramModal] = useState(false);
    const [showEnabledProgramModal, setShowEnabledProgramModal] = useState(false);
    const [showDeleteProgramModal, setShowDeleteProgramModal] = useState(false);

    const [showToastSuccess, setShowToastSuccess] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const handleShowToastSuccess = (message: string) => {
        setToastMessage(message);
        setShowToastSuccess(true);

        setTimeout(() => {
            setShowToastSuccess(false);
            setToastMessage("");
        }, 3000);
    }

    const handleShowDisabledProgramModal = (program: IProgram) => {
        setProgramSelected(program);
        setShowDisabledProgramModal(true)
    };

    const handleShowEnabledProgramModal = (program: IProgram) => {
        setProgramSelected(program);
        setShowEnabledProgramModal(true)
    };

    const handleShowDeleteProgramModal = (program: IProgram) =>  {
        setProgramSelected(program);
        setShowDeleteProgramModal(true)
    };

    const handleDisabledProgram = () => {
        const newPrograms: IProgram[] = programs;

        const index: number = newPrograms.findIndex((programFind: IProgram) => programFind.programId === programSelected.programId);

        if (index >= 0) {
            newPrograms[index].status = "disabled";
            setPrograms(newPrograms);
            setProgramSelected({} as IProgram);
        }

        handleShowToastSuccess("Se ha deshabilitado el programa con éxito");
    };

    const handleEnabledProgram = () => {
        const newPrograms: IProgram[] = programs;

        const index: number = newPrograms.findIndex((programFind: IProgram) => programFind.programId === programSelected.programId);

        if (index >= 0) {
            newPrograms[index].status = "draft";
            setPrograms(newPrograms);
            setProgramSelected({} as IProgram);
        }

        handleShowToastSuccess("Se ha habilitado el programa con éxito");
    };

    const handleDeleteProgram = () => {
        const newPrograms: IProgram[] = programs;

        const index: number = newPrograms.findIndex((programFind: IProgram) => programFind.programId === programSelected.programId);

        if (index >= 0) {
            newPrograms[index].status = "draft";
            setPrograms(newPrograms);
            setProgramSelected({} as IProgram);
        }

        handleShowToastSuccess("Se ha eliminado el programa con éxito");
    };

    return (
        <>
        <Table size="sm" responsive="md" className="text-center table-center">
            <thead className="thead-border">
                <tr>
                    <th>Nombre del programa</th>
                    <th>Estatus</th>
                    <th>Opciones</th>
                </tr>
            </thead>
            <tbody>
                {programs.slice(0, limit).map((program: IProgram) => (
                    <tr key={program.programId}>
                        <td className="cell-overflow">
                            <span>{program.name.length > 0 ? program.name : program.programCategory}</span>
                        </td>

                        <td>{getProgramStatus(program?.status ?? "")}</td>

                        <td className="text-center">
                            <Dropdown>
                                <Dropdown.Toggle variant="" id="dropdown-toogle dropdown-options" style={{boxShadow: "none"}}>
                                    Ver
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Link to={`/admin/dashboard/settings/program/${program.programId}`} className="dropdown-item btn" style={{boxShadow: "none"}}>
                                        Ver programa
                                    </Link>

                                    <Link to={`/admin/dashboard/settings/programs/${program.programId}/edit`} className="dropdown-item btn" style={{boxShadow: "none"}}>
                                        Editar
                                    </Link>

                                    {program?.status === "disabled" ? (
                                        <Button onClick={() => handleShowEnabledProgramModal(program)} variant="" className="dropdown-item" style={{boxShadow: "none"}}>
                                            Habilitar
                                        </Button>
                                    ) : (
                                        <Button onClick={() => handleShowDisabledProgramModal(program)} variant="" className="dropdown-item" style={{boxShadow: "none"}}>
                                            Deshabilitar
                                        </Button>
                                    )}

                                    <Button onClick={() => handleShowDeleteProgramModal(program)} variant="" className="dropdown-item" style={{boxShadow: "none"}}>
                                        Eliminar
                                    </Button>
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <div className="d-flex justify-content-end">
            <Pagination />
        </div>

        {showDisabledProgramModal && programSelected?.programId && (
            <DisabledProgramModal
            show={showDisabledProgramModal}
            onHide={() => setShowDisabledProgramModal(false)}
            animation={false}
            program={programSelected}
            handleDisabledProgram={handleDisabledProgram}
            />
        )}

        {showEnabledProgramModal && programSelected?.programId && (
            <EnabledProgramModal
            show={showEnabledProgramModal}
            onHide={() => setShowEnabledProgramModal(false)}
            animation={false}
            program={programSelected}
            handleEnabledProgram={handleEnabledProgram}
            />
        )}

        {showDeleteProgramModal && programSelected?.programId && (
            <DeleteProgramModal
            show={showDeleteProgramModal}
            onHide={() => setShowDeleteProgramModal(false)}
            animation={false}
            program={programSelected}
            handleDeleteProgram={handleDeleteProgram}
            />
        )}

        <Toast 
        style={{position: 'fixed', bottom: '10px', left: '220px'}} 
        show={showToastSuccess} 
        className="toast-success"
        >
            <Toast.Body>
                {toastMessage}
            </Toast.Body>
        </Toast>
        </>
    )
}